import { useSearchParams } from 'react-router-dom';
import { SectionTabs } from '../components/SectionTabs';
import { PortalUsers } from './PortalUsers';
import { StaffUsers } from './StaffUsers';

const TABS = [
  { key: 'portal', label: 'Portal users' },
  { key: 'office', label: 'Office users' },
];

/**
 * Everyone who can sign in: cleaners to the portal, and staff to the office.
 * Office users are the owner's alone (granting office access is in the same
 * league as billing), so anyone else sees only the portal list, with no tabs.
 */
export function Users({ canManageOffice }: { canManageOffice: boolean }) {
  const [params] = useSearchParams();
  const tab = canManageOffice && params.get('tab') === 'office' ? 'office' : 'portal';
  return (
    <>
      <h1>Users</h1>
      {canManageOffice && (
        <SectionTabs
          label="Users sections"
          tabs={TABS}
          current={tab}
          to={(k) => `/users?tab=${k}`}
        />
      )}
      {tab === 'portal' ? <PortalUsers /> : <StaffUsers />}
    </>
  );
}
